import React, { Fragment, lazy } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Loader from "./Layouts/Loader/Loader";
import "./index.scss";
import reportWebVitals from "./reportWebVitals";
import { ToastContainer } from "react-toastify";

const App = lazy(() => import("./components/app"));
const Login = lazy(() => import("./components/Authentication/Login/Login"));
const AuthenticationPage = lazy(() =>
  import("./components/AuthenticationPage")
);
const Dashboard = lazy(() => import("./pages/analytics"));
const Quotes = lazy(() => import("./pages/customer-engagements/quotes/index"));
const Reviews = lazy(() => import("./pages/customer-engagements/reviews"));
const Tags = lazy(() => import("./pages/stocks/tags"));
const AddTags = lazy(() => import("./pages/stocks/tags/add"));
const Gallery = lazy(() => import("./pages/setting/gallery"));
const AddGallery = lazy(() => import("./pages/setting/gallery/add"));
const Orders = lazy(() => import("./pages/orders"));
const AddOrder = lazy(() => import("./pages/orders/addOrder"));
const ViewOrder = lazy(() => import("./pages/orders/viewOrder"));
const Catalog = lazy(() => import("./pages/stocks/catalog"));
const AddCatalog = lazy(() => import("./pages/stocks/catalog/add"));
const Category = lazy(() => import("./pages/stocks/category"));
const AddCategory = lazy(() => import("./pages/stocks/category/add"));
const SubCategory = lazy(() => import("./pages/stocks/sub-category"));
const AddSubCategory = lazy(() => import("./pages/stocks/sub-category/add"));
const Attribute = lazy(() => import("./pages/stocks/attribute"));
const AddAttribute = lazy(() => import("./pages/stocks/attribute/add"));
const Brands = lazy(() => import("./pages/stocks/brands"));
const AddBrands = lazy(() => import("./pages/stocks/brands/add"));
const VehicleType = lazy(() => import("./pages/stocks/vehicle-type"));
const AddVehicleType = lazy(() => import("./pages/stocks/vehicle-type/add"));
const AddProductCode = lazy(() => import("./pages/stocks/codes/add"));
const ProductCode = lazy(() => import("./pages/stocks/codes"));
const Websites = lazy(() => import("./pages/setting/websites"));
const AddWebsite = lazy(() => import("./pages/setting/websites/add"));
const User = lazy(() => import("./pages/setting/user"));
const AddUser = lazy(() => import("./pages/setting/user/add"));
const AddProduct = lazy(() => import("./pages/stocks/product/add"));
const Product = lazy(() => import("./pages/stocks/product"));
const DeletedProducts = lazy(() => import("./pages/stocks/product/delete"));
const AddVendor = lazy(() => import("./pages/purchase/vendor/add"));
const Vendor = lazy(() => import("./pages/purchase/vendor"));
const ViewInvoice = lazy(() => import("./pages/purchase/list/invoice"));
const AddPurchase = lazy(() => import("./pages/purchase/list/add"));
const Purchases = lazy(() => import("./pages/purchase/list"));
const Coupon = lazy(() => import("./pages/setting/coupons"));
const AddCoupon = lazy(() => import("./pages/setting/coupons/add"));
const Shipment = lazy(() => import("./pages/setting/shipment"));
const AddShipment = lazy(() => import("./pages/setting/shipment/add"));


const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Fragment>
      <BrowserRouter>
        <React.Suspense fallback={<Loader />}>
          <Routes>
            {/* Authentication Pages */}
            <Route path={``} element={<AuthenticationPage />}>
              <Route path={`/login`} element={<Login />} />
            </Route>
            <Route path={``} element={<App />}>
              <Route path={`dashboard`} element={<Dashboard />} />
              <Route path="/stock">
                <Route path={`catalog`}>
                  <Route path={``} element={<Catalog />} />
                  <Route path={`add`} element={<AddCatalog />} />
                  <Route path={`add/:id`} element={<AddCatalog />} />
                </Route>
                <Route path={`category`}>
                  <Route path={``} element={<Category />} />
                  <Route path={`add`} element={<AddCategory />} />
                  <Route path={`add/:id`} element={<AddCategory />} />
                </Route>
                <Route path={`sub_category`}>
                  <Route path={``} element={<SubCategory />} />
                  <Route path={`add`} element={<AddSubCategory />} />
                  <Route path={`add/:id`} element={<AddSubCategory />} />
                </Route>
                <Route path={`product`}>
                  <Route path={`add`} element={<AddProduct />} />
                  <Route path={`deleted`} element={<DeletedProducts />} />
                  <Route path={``} element={<Product />} />
                  <Route path={`add/:id`} element={<AddProduct />} />
                </Route>
                <Route path={`attribute`}>
                  <Route path={`add`} element={<AddAttribute />} />
                  <Route path={``} element={<Attribute />} />
                  <Route path={`add/:id`} element={<AddAttribute />} />
                </Route>
                <Route path={`brand`}>
                  <Route path={`add`} element={<AddBrands />} />
                  <Route path={``} element={<Brands />} />
                  <Route path={`add/:id`} element={<AddBrands />} />
                </Route>
                <Route path={`vehicle_type`}>
                  <Route path={`add`} element={<AddVehicleType />} />
                  <Route path={``} element={<VehicleType />} />
                  <Route path={`add/:id`} element={<AddVehicleType />} />
                </Route>
                <Route path={`codes`}>
                  <Route path={`add`} element={<AddProductCode />} />
                  <Route path={``} element={<ProductCode />} />
                  <Route path={`add/:id`} element={<AddProductCode />} />
                </Route>
                <Route path={`tags`}>
                  <Route path={`add`} element={<AddTags />} />
                  <Route path={``} element={<Tags />} />
                  <Route path={`add/:id`} element={<AddTags />} />
                </Route>
              </Route>
              <Route path="/setting">
                <Route path={`website`}>
                  <Route path={``} element={<Websites />} />
                  <Route path={`add`} element={<AddWebsite />} />
                  <Route path={`add/:id`} element={<AddWebsite />} />
                </Route>
                <Route path={`user`}>
                  <Route path={``} element={<User />} />
                  <Route path={`add`} element={<AddUser />} />
                  <Route path={`add/:id`} element={<AddUser />} />
                </Route>
                <Route path={`gallery`}>
                  <Route path={``} element={<Gallery />} />
                  <Route path={`add`} element={<AddGallery />} />
                  <Route path={`add/:id`} element={<AddGallery />} />
                </Route>
                <Route path={`coupon`}>
                  <Route path={``} element={<Coupon />} />
                  <Route path={`add`} element={<AddCoupon />} />
                  <Route path={`add/:id`} element={<AddCoupon />} />
                </Route>
                <Route path={`shipment`}>
                  <Route path={``} element={<Shipment />} />
                  <Route path={`add`} element={<AddShipment />} />
                  <Route path={`add/:id`} element={<AddShipment />} />
                </Route>
              </Route>

              <Route path="/purchase">
                <Route path={`vendor`}>
                  <Route path={``} element={<Vendor />} />
                  <Route path={`add`} element={<AddVendor />} />
                  <Route path={`add/:id`} element={<AddVendor />} />
                </Route>
                <Route path={`list`}>
                  <Route path={`:id`} element={<ViewInvoice />} />
                  <Route path={``} element={<Purchases />} />
                  <Route path={`add`} element={<AddPurchase />} />
                  <Route path={`add/:id`} element={<AddPurchase />} />
                </Route>
              </Route>

              {/* quotes */}
              <Route path="/customer_interaction">
                <Route path="quotes" element={<Quotes />} />
                <Route path="reviews" element={<Reviews />} />
              </Route>

              <Route path="/orders">
                <Route path="" element={<Orders />} />
                <Route path="add" element={<AddOrder />} />
                <Route path=":id" element={<ViewOrder />} />
              </Route>
 
            </Route>
          </Routes>
        </React.Suspense>
      </BrowserRouter>
    </Fragment>
    <ToastContainer />
  </React.StrictMode>
);

reportWebVitals();
